// 'Pseudo' class here just to increase selectivity to override default material UI instead of using !important

import React, {Component} from 'react';
import _ from 'lodash';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import GamesIcon from '../assets/images/icon_games_keystats.png'
import ShopeepayIcon from '../assets/images/icon_shopeepay_keystats.png'
import KeystatsIcon from '../assets/images/icon_keystats.png'
import ShopeefoodIcon from '../assets/images/icon_shopeefood_keystats.png'
import OchaIcon from '../assets/images/icon_ocha_keystats.png'
import ShopeeIcon from '../assets/images/icon_shopee_keystats.png'
import SeabankIcon from '../assets/images/icon_seabank_keystats.png'
import CreditIcon from '../assets/images/icon_credit_keystats.png'
import SPXIcon from '../assets/images/icon_spx_keystats.png'
import DummyAvatar from '../assets/images/profile_photo.jpg'

import '../assets/css/Header.css';
import {Utils} from '../common/utils.jsx';
import {ApiPath} from '../common/properties.jsx'

class Header extends Component {

    static getProductDetails(product) {
        let icon;
        let title;
        switch (product) {
            case 'games':
                icon = GamesIcon;
                title = 'Games Keystats';
                break;
            case 'shopeepay':
                icon = ShopeepayIcon;
                title = 'ShopeePay Keystats';
                break;
            case 'shopee':
                icon = ShopeeIcon;
                title = 'Shopee Keystats';
                break;
            case 'foody':
                icon = ShopeefoodIcon;
                title = 'ShopeeFood Keystats';
                break;
            case 'ocha':
                icon = OchaIcon;
                title = 'Ocha Keystats';
                break;
            case 'money':
                icon = SeabankIcon;
                title = 'SeaBank Keystats';
                break;
            case 'keystats':
                icon = KeystatsIcon;
                title = 'Keystats';
                break;
            case 'credit':
                icon = CreditIcon;
                title = 'Credit Keystats';
                break;
            case 'spx':
                icon = SPXIcon;
                title = 'SPX Keystats';
                break;
            default:
                icon = KeystatsIcon;
                title = 'Keystats';
                break;
        }
        return {
            icon: icon,
            title: title
        }
    }

    constructor(props) {
        super(props);
        window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
        this.state = {
            product: _.get(props.meta, 'client', 'keystats'),
            profileOpen: false,
            patOpen: false,
            patLoading: false,
            patError: '',
            patDetails: {},
        };
    }

    handleClose(event) {
        let button = document.getElementById('profile');
        if (button.contains(event.target) && this.state.profileOpen) {
            return;
        }
        this.setState({profileOpen: false});
    }

    handleLogout(event) {
        this.handleClose(event);
        let logoutPath = ApiPath.logout;
        Promise.resolve(Utils.getApiResponse(logoutPath))
               .then(_ => document.location.replace(ApiPath.home));
    }

    handlePatManagement(event) {
        this.handleClose(event);
        this.setState({
            patOpen: true,
            patLoading: true,
            patError: '',
        });
        Promise.resolve(Utils.getApiResponse(ApiPath.pat))
            .then(response => {
                this.setState({
                    patDetails: response.data,
                    patLoading: false,
                });
            })
            .catch(() => {
                this.setState({
                    patError: 'Unable to load PAT details. Please try again.',
                    patLoading: false,
                });
            });
    }

    handlePatDialogClose() {
        this.setState({patOpen: false});
    }

    handleGeneratePat() {
        let currentPat = _.get(this.state.patDetails, 'pat', '');
        let message = currentPat
            ? 'This will revoke your current PAT and create a new one-year token. Continue?'
            : 'Create a one-year PAT for MCP access?';
        if (!window.confirm(message)) {
            return;
        }

        this.setState({
            patLoading: true,
            patError: '',
        });
        Promise.resolve(Utils.postApiResponse(ApiPath.pat))
            .then(response => {
                this.setState({
                    patDetails: response.data,
                    patLoading: false,
                });
            })
            .catch(() => {
                this.setState({
                    patError: 'Unable to create a new PAT. Please try again.',
                    patLoading: false,
                });
            });
    }

    handleToggle() {
        this.setState(prevState => ({
            profileOpen: !prevState.profileOpen
        }));

    }

    renderProfile() {
        let displayName = _.get(this.props.meta.user_details, 'display_name', 'User');
        let pic = _.get(this.props.meta.user_details, 'pic', DummyAvatar);
        return (
            <Button
                ref=''
                aria-controls="profile__menu"
                aria-haspopup="true"
                onClick={() => this.handleToggle()}
                id="profile"
                className="toolbar__profile profile pseudo"
            >
                {this.getProfilePictureFromLink(pic)}
                <Typography className="profile__name pseudo font--normal">
                    {displayName}
                </Typography>
            </Button>
        )
    }

    getProfilePictureFromLink(link) {
        return (
            <img src={link} className={"profile__picture"} alt="" onError={event => {event.target.src = DummyAvatar}}/>
        );
    }

    renderProfilePopup() {
        let isGames = this.state.product === 'games';
        return (
            <Popper open={this.state.profileOpen}
                    anchorEl={document.getElementById("profile")}
                    transition disablePortal
            >
                {({ TransitionProps}) => (
                    <Grow
                        {...TransitionProps}
                    >
                        <Paper id='profile__menu' className='profile__menu menu pseudo'>
                            <ClickAwayListener onClickAway={event => this.handleClose(event)}>
                                <MenuList className='menu__list pseudo'>
                                    {isGames &&
                                        <MenuItem onClick={event => this.handlePatManagement(event)}
                                                  className='menu__item menu__item--wide pseudo font--normal'
                                        >
                                            <span className='menu__text'>
                                                Manage PAT
                                            </span>
                                        </MenuItem>
                                    }
                                    <MenuItem onClick={event => this.handleLogout(event)}
                                              className={`menu__item ${isGames ? 'menu__item--wide' : ''} pseudo font--normal`}
                                    >
                                        <span className='menu__text'>
                                            Logout
                                        </span>
                                    </MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        )
    }

    renderPatDialog() {
        let pat = _.get(this.state.patDetails, 'pat', '');
        let expiresAt = _.get(this.state.patDetails, 'expires_at', '');
        let statusText = pat
            ? `Valid until: ${expiresAt}`
            : 'No active PAT is available.';
        return (
            <Dialog open={this.state.patOpen}
                    onClose={() => this.handlePatDialogClose()}
                    maxWidth="sm"
                    fullWidth
            >
                <DialogTitle>Manage PAT</DialogTitle>
                <DialogContent>
                    <Typography className='pat__status pseudo font--normal'>
                        {this.state.patLoading ? 'Loading...' : statusText}
                    </Typography>
                    {pat &&
                        <div className='pat__value-wrapper'>
                            <input className='pat__value' readOnly value={pat}/>
                        </div>
                    }
                    {this.state.patError &&
                        <Typography className='pat__error pseudo font--normal'>
                            {this.state.patError}
                        </Typography>
                    }
                    <Typography className='pat__hint pseudo font--normal'>
                        Only the latest PAT is valid. Creating a new one revokes the previous token and sets a one-year expiry.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.handlePatDialogClose()}
                            color="default"
                            disabled={this.state.patLoading}
                    >
                        Close
                    </Button>
                    <Button onClick={() => this.handleGeneratePat()}
                            color="primary"
                            disabled={this.state.patLoading}
                    >
                        Generate PAT
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    render() {
        let productDetails = Header.getProductDetails(this.state.product);
        let iconSource = productDetails.icon;
        let productTitle = productDetails.title;

        return (
            <AppBar position='fixed' classes={{root: 'header pseudo'}}>
                <Toolbar classes={{root: 'header__toolbar toolbar pseudo'}}>
                    <img src={iconSource} alt='' className='toolbar__logo'/>
                    <Typography className='toolbar__title font--bold pseudo'>
                        {productTitle}
                    </Typography>
                    {this.renderProfile()}
                    {this.renderProfilePopup()}
                    {this.renderPatDialog()}
                </Toolbar>
            </AppBar>
        );
    }
}

export default Header;
